module.exports = __webpack_public_path__ + "img/1523348218.92814b62.jpg";